import React from 'react';
import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';
import './LegalDocument.css';

const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://letter-quest.com';

export default function TermsOfUsePage() {
  return (
    <main className="legal-page">
      <SeoHead
        title="Terms of Use"
        description="Terms and conditions for using Letter Quest games on the web and in our mobile apps."
        path="/terms"
      />
      <h1>Terms of Use</h1>
      <p className="legal-meta">
        Last updated: April 13, 2026 · Applies to:{' '}
        <a href={SITE_URL.replace(/\/$/, '')}>{SITE_URL.replace(/\/$/, '')}</a> and the Letter Quest mobile apps when
        they reference these terms.
      </p>

      <p>
        These Terms of Use (&quot;Terms&quot;) govern your access to and use of Letter Quest (the &quot;Service&quot;),
        including our website and mobile applications. By using the Service, you agree to these Terms.
      </p>

      <h2>Eligibility and accounts</h2>
      <p>
        You must comply with the minimum age and eligibility rules of your app store and jurisdiction. You are
        responsible for activity under your account and for keeping your login credentials confidential.
      </p>

      <h2>License</h2>
      <p>
        We grant you a personal, non-exclusive, non-transferable, revocable license to use the Service for
        entertainment in line with these Terms. All rights not expressly granted are reserved.
      </p>

      <h2>Acceptable use</h2>
      <ul>
        <li>Do not cheat, manipulate scores, harass others, or attempt to break or overload the Service.</li>
        <li>Do not reverse engineer, scrape, or misuse our APIs except as allowed by normal client use.</li>
        <li>Do not use the Service for unlawful purposes or in violation of third-party rights.</li>
      </ul>

      <h2>User content</h2>
      <p>
        If you submit content (such as display names), you grant us a license to host and display it as needed to run
        the Service. You represent that you have the rights to anything you submit.
      </p>

      <h2>Virtual items and purchases</h2>
      <p>
        If we offer purchases or virtual items in the future, additional terms may apply at the point of sale. For now,
        the Service is offered as-is without warranties of uninterrupted or error-free operation.
      </p>

      <h2>Disclaimer of warranties</h2>
      <p>
        THE SERVICE IS PROVIDED &quot;AS IS&quot; AND &quot;AS AVAILABLE&quot; WITHOUT WARRANTIES OF ANY KIND, WHETHER
        EXPRESS OR IMPLIED, INCLUDING IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
        NON-INFRINGEMENT, TO THE MAXIMUM EXTENT PERMITTED BY LAW.
      </p>

      <h2>Limitation of liability</h2>
      <p>
        TO THE MAXIMUM EXTENT PERMITTED BY LAW, LETTER QUEST AND ITS AFFILIATES WILL NOT BE LIABLE FOR ANY INDIRECT,
        INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR DATA, ARISING FROM YOUR USE
        OF THE SERVICE. OUR TOTAL LIABILITY FOR ANY CLAIM ARISING OUT OF THESE TERMS OR THE SERVICE WILL NOT EXCEED THE
        GREATER OF (A) THE AMOUNT YOU PAID US FOR THE SERVICE IN THE TWELVE MONTHS BEFORE THE CLAIM OR (B) FIFTY US
        DOLLARS (US $50), IF YOU HAVE NOT PAID US.
      </p>

      <h2>Indemnity</h2>
      <p>
        You agree to defend and indemnify us against claims arising from your misuse of the Service or violation of
        these Terms, to the extent permitted by law.
      </p>

      <h2>Termination</h2>
      <p>
        We may suspend or terminate access to the Service if you violate these Terms or if we discontinue the Service.
        Provisions that by their nature should survive will survive termination.
      </p>

      <h2>Changes</h2>
      <p>
        We may modify these Terms. We will post the updated version on this page with a new &quot;Last updated&quot;
        date. Continued use after changes constitutes acceptance unless applicable law requires a different process.
      </p>

      <h2>Governing law</h2>
      <p>
        These Terms are governed by the laws applicable in your primary place of business or residence as we may
        specify in a future version, excluding conflict-of-law rules. Until then, disputes should be raised through the
        support channel on your app store listing.
      </p>

      <h2>Contact</h2>
      <p>
        For questions about these Terms, use the support or contact method shown on your app store listing or on{' '}
        <a href={SITE_URL.replace(/\/$/, '')}>{SITE_URL.replace(/\/$/, '')}</a>.
      </p>

      <p>
        Related: <Link to="/privacy">Privacy Policy</Link>
      </p>

      <p className="legal-disclaimer">
        This document is a practical template for a small indie product. It is not legal advice. Have qualified counsel
        review and localize it before production store submission.
      </p>
    </main>
  );
}
